// extracted by mini-css-extract-plugin
module.exports = {"margin_large":"20px","blue":"#2e4250","blue_light":"#6bbaf1"};